import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';

import Home from '../views/index.vue';
import  store, { storeLoadedResolve } from '../store';
import { produtosLiberado } from '../constants/produtos';
//import  store from '../store';

const routes = [
    //dashboard
    { path: '/', name: 'Home', component: Home, meta: { breadcrumbs: ['Dashboard', 'Meu Painel'] } },

    {
        path: '/index2',
        name: 'index2',
        component: () => import(/* webpackChunkName: "index2" */ '../views/index2.vue'),
        meta: { breadcrumbs: ['Dashboard', 'Novas Oportunidades'] },
    },

    //configs
    {
        path: '/configs/central',
        name: 'centralempresas',
        component: () => import(/* webpackChunkName: "centralempresas" */ '../views/configs/central.vue'),
        meta: { breadcrumbs: ['Configurações', 'Central de Empresas'] },
    },
    {
        path: '/configs/loginsportal',
        name: 'loginsportal',
        component: () => import(/* webpackChunkName: "loginsportal" */ '../views/configs/loginsportal.vue'),
        meta: { breadcrumbs: ['Configurações', 'Logins de Portais'] },
    },
    {
        path: '/configs/alertasgeral',
        name: 'alertasgeral',
        component: () => import(/* webpackChunkName: "alertasgeral" */ '../views/configs/alertasgeral.vue'),
        meta: { breadcrumbs: ['Configurações', 'Alertas'] },
    },
    {
        path: '/configs/representados',
        name: 'representados',
        component: () => import(/* webpackChunkName: "representados" */ '../views/configs/representados.vue'),
        meta: { breadcrumbs: ['Configurações', 'Representados'] },
    },
    {
        path: '/configs/logssincronia',
        name: 'logssincronia',
        component: () => import(/* webpackChunkName: "logssincronia" */ '../views/configs/logssincronia.vue'),
        meta: { breadcrumbs: ['Configurações', 'Logs de Sincronia'] },
    },
    {
        path: '/configs/celulares',
        name: 'celulares',
        component: () => import(/* webpackChunkName: "celulares" */ '../views/configs/celulares.vue'),
        meta: { breadcrumbs: ['Configurações', 'Celulares'] },
    },
    {
        path: '/configs/documentacao',
        name: 'documentacao',
        component: () => import(/* webpackChunkName: "documentacao" */ '../views/configs/documentacao.vue'),
        meta: { breadcrumbs: ['Configurações', 'Documentação Final'] },
    },
    {
        path: '/configs/documentos',
        name: 'documentos_empresa',
        component: () => import(/* webpackChunkName: "documentos-empresa" */ '../views/configs/documentos_empresa.vue'),
        meta: { breadcrumbs: ['Configurações', 'Documentos da Empresa'] },
    },

    //pages
    {
        path: '/pages/maintenence',
        name: 'maintenence',
        component: () => import(/* webpackChunkName: "pages-maintenence" */ '../views/pages/maintenence.vue'),
        meta: { layout: 'auth' },
    },

    //auth
    {
        path: '/auth/login-boxed',
        name: 'login-boxed',
        component: () => import(/* webpackChunkName: "auth-login-boxed" */ '../views/auth/login_boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/logout',
        name: 'logout',
        component: () => import(/* webpackChunkName: "auth-login-boxed" */ '../views/auth/logout.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/lockscreen-boxed',
        name: 'lockscreen-boxed',
        component: () => import(/* webpackChunkName: "auth-lockscreen-boxed" */ '../views/auth/lockscreen_boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/pass-recovery-boxed',
        name: 'pass-recovery-boxed',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/pass_recovery_boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/lockscreen',
        name: 'lockscreen',
        component: () => import(/* webpackChunkName: "auth-lockscreen" */ '../views/auth/lockscreen.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/troca-senha-boxed',
        name: 'troca-senha-boxed',
        component: () => import(/* webpackChunkName: "auth-troca-senha-boxed" */ '../views/auth/troca-senha-boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/sistema-atualizado',
        name: 'sistema-atualizado',
        component: () => import(/* webpackChunkName: "auth-sistema-atualizado" */ '../views/auth/sistema_atualizado.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/erro-migration',
        name: 'erro-migration',
        component: () => import(/* webpackChunkName: "auth-erro-migration" */ '../views/auth/erro_migration.vue'),
        meta: { layout: 'auth' },
    },

    //users
    {
        path: '/users/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "users-profile" */ '../views/users/profile.vue'),
        meta: { breadcrumbs: ['Usuário', 'Perfil'] },
    },
    {
        path: '/users/troca-senha',
        name: 'troca-senha',
        component: () => import(/* webpackChunkName: "users-troca-senha" */ '../views/users/troca_senha.vue'),
        meta: { breadcrumbs: ['Usuário', 'Troca de Senha'] },
    },

    //apps
    {
        path: '/apps/pregoes',
        name: 'pregoes',
        component: () => import(/* webpackChunkName: "apps-pregoes" */ '../views/apps/pregoes/pregoes.vue'),
        meta: { breadcrumbs: ['Minhas Licitações', 'Pregões'] },
    },
    {
        path: '/apps/busca',
        name: 'busca',
        component: () => import(/* webpackChunkName: "apps-busca" */ '../views/apps/busca/busca.vue'),
        meta: { breadcrumbs: ['Busca de Editais'] },
    },
    {
        path: '/apps/boletins',
        name: 'boletins',
        component: () => import(/* webpackChunkName: "apps-boletins" */ '../views/apps/boletins/boletins.vue'),
        meta: { breadcrumbs: ['Boletins'] },
    },
    {
        path: '/apps/calendar',
        name: 'calendar',
        component: () => import(/* webpackChunkName: "apps-calendar" */ '../views/apps/pregoes/calendar.vue'),
        meta: { breadcrumbs: ['Minhas Licitações', 'Calendário'] },
    },
    {
        // Catálogo de produtos: liberado só para empresas da lista de constants/produtos.js
        path: '/apps/produtos',
        name: 'produtos',
        component: () => import(/* webpackChunkName: "apps-produtos" */ '../views/apps/produtos/produtos.vue'),
        meta: { breadcrumbs: ['Minhas Licitações', 'Produtos'], requiresProdutos: true },
    },
    {
        // Cadastro de fornecedores do catálogo (acesso pelo botão "Fornecedores" de /apps/produtos)
        path: '/apps/produtos/fornecedores',
        name: 'produtos-fornecedores',
        component: () => import(/* webpackChunkName: "apps-produtos" */ '../views/apps/produtos/produtos_fornecedores.vue'),
        meta: { breadcrumbs: ['Minhas Licitações', 'Produtos', 'Fornecedores'], requiresProdutos: true },
    },
    {
        // Oportunidades de produtos (Task 22): sugestões do job diário agrupadas por licitação
        // (destino do aviso do sino "Oportunidades de produtos")
        path: '/apps/produtos/oportunidades',
        name: 'produtos-oportunidades',
        component: () => import(/* webpackChunkName: "apps-produtos" */ '../views/apps/produtos/oportunidades.vue'),
        meta: { breadcrumbs: ['Minhas Licitações', 'Produtos', 'Oportunidades'], requiresProdutos: true },
    },
    {
        path: '/apps/alertas',
        name: 'alertas',
        component: () => import(/* webpackChunkName: "apps-calendar" */ '../views/apps/alertas/alertas.vue'),
        meta: { breadcrumbs: ['Alertas'] },
    },

    //lances
    {
        path: '/apps/lances/comprasnet',
        name: 'lances-comprasnet',
        component: () => import(/* webpackChunkName: "apps-lances-comprasnet" */ '../views/apps/lances/ComprasNET/ComprasNetLista.vue'),
        meta: { requiresLanceWeb: true, breadcrumbs: ['Lances', 'ComprasNET'] },
    },
    {
        path: '/apps/lances/dispensa',
        name: 'lances-dispensa',
        component: () => import(/* webpackChunkName: "apps-lances-dispensa" */ '../views/apps/lances/ComprasNET/DispensaLance.vue'),
        meta: { requiresLanceWeb: true, layout: 'fullscreen' },
    },

    // BNC
    {
        path: '/apps/lances/bnc',
        name: 'lances-bnc',
        component: () => import(/* webpackChunkName: "apps-lances-bncbll" */ '../views/apps/lances/BncBll/BncBllLista.vue'),
        meta: { requiresLanceWeb: true, idPortal: 8, breadcrumbs: ['Lances', 'BNC'] },
    },
    // BLL
    {
        path: '/apps/lances/bll',
        name: 'lances-bll',
        component: () => import(/* webpackChunkName: "apps-lances-bncbll" */ '../views/apps/lances/BncBll/BncBllLista.vue'),
        meta: { requiresLanceWeb: true, idPortal: 5, breadcrumbs: ['Lances', 'BLL'] },
    },
    // PCP - Portal de Compras Públicas
    {
        path: '/apps/lances/pcp',
        name: 'lances-pcp',
        component: () => import(/* webpackChunkName: "apps-lances-pcp" */ '../views/apps/lances/Pcp/PcpLista.vue'),
        meta: { requiresLanceWeb: true, breadcrumbs: ['Lances', 'PCP'] },
    },
    // PCP - Sala de Lances
    {
        path: '/apps/lances/pcp/lance',
        name: 'lances-pcp-lance',
        component: () => import(/* webpackChunkName: "apps-lances-pcp-lance" */ '../views/apps/lances/Pcp/PcpLance.vue'),
        meta: { requiresLanceWeb: true, layout: 'fullscreen' },
    },
    // ComprasNET - Sala de Disputa (somente Pregão Eletrônico)
    {
        path: '/apps/lances/pregao/lance',
        name: 'lances-pregao-lance',
        component: () => import(/* webpackChunkName: "apps-lances-pregao-lance" */ '../views/apps/lances/ComprasNET/PregaoLance.vue'),
        meta: { requiresLanceWeb: true, layout: 'fullscreen' },
    },
];

const router = new createRouter({
    // mode: 'history',
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach(async (to, from, next) => {

    let bUserLogado = store.getters.userLogado;
    let bTelaTrancada = store.getters.telaTrancada;

    if (!bUserLogado) { //verificando em localstorage
        let _userDados = JSON.parse(localStorage.getItem('userDados'));
        if (_userDados) {
            let _dadosBusca = localStorage.getItem('buscaDados')
                ? JSON.parse(localStorage.getItem('buscaDados'))
                : null;

            if (_dadosBusca)
                store.commit('changeBuscaDados', _dadosBusca);

            bTelaTrancada = JSON.parse(localStorage.getItem('telaTrancada'));
            if (_userDados && _userDados.token) {
                store.commit('changeUserLogado', true);
                store.commit('changeUserDados', _userDados);
                store.commit('setUserDadosLoaded', true); // Mantenha esta linha!
                storeLoadedResolve();
                bUserLogado = true;

                // Multi-CNPJ: rehidrata a empresa ativa selecionada antes do reload
                try {
                    const _empresaAtiva = JSON.parse(localStorage.getItem('empresaAtiva') || 'null');
                    if (_empresaAtiva?.cnpj) store.commit('setEmpresaAtiva', _empresaAtiva);
                } catch { /* seleção corrompida é ignorada */ }

                // Verificação de migrations pendentes no reload do browser (F5).
                // Roda 1x por carregamento de página (flag no window para evitar loop).
                if (!window.__migChecked && to.name !== 'sistema-atualizado' && to.name !== 'erro-migration') {
                    window.__migChecked = true;
                    try {
                        // Multi-CNPJ: verifica o banco da empresa ativa (header contextualiza o request)
                        const _headers = { Authorization: 'Bearer ' + _userDados.token };
                        const _empAtiva = store.getters.empresaAtiva;
                        if (_empAtiva?.cnpj && _empAtiva.cnpj !== _userDados.cnpj)
                            _headers['X-Empresa-Cnpj'] = _empAtiva.cnpj;

                        const res = await axios.get(
                            process.env.VUE_APP_BASE_URL + '/api/User/VerificarAtualizacaoBD',
                            { headers: _headers }
                        );
                        const d = res.data?.data;
                        if (d) {
                            // Detecta se a versão do banco mudou em relação ao que está no localStorage.
                            // Isso cobre o caso em que a migration rodou no startup da API (antes do F5).
                            const versaoMudou = d.versao && _userDados.versaobd !== d.versao;

                            // Atualiza versão no userDados (store + localStorage) para o footer refletir
                            if (versaoMudou) {
                                _userDados.versaobd = d.versao;
                                _userDados.versaobduser = d.versao;
                                localStorage.setItem('userDados', JSON.stringify(_userDados));
                                store.commit('changeUserDados', _userDados);
                            }

                            // Erro na migration — redireciona para página de erro
                            if (d.sucesso === false && d.erroDetalhado) {
                                localStorage.setItem('_migErro', d.erroDetalhado);
                                return next('/auth/erro-migration');
                            }
                            // Migrations aplicadas agora OU versão diferente da salva (migration rodou no startup)
                            if (d.migracoesAplicadas > 0 || versaoMudou) {
                                localStorage.setItem('_migVersao', d.versao);
                                return next('/auth/sistema-atualizado');
                            }
                        }
                    } catch (err) {
                        console.warn('Erro ao verificar atualização do BD:', err.message);
                    }
                }
            }
        } else {
            console.log("Logina primeira vez...");
        }
    }


    if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
        store.commit('setLayout', 'auth');
    } else {

        if (!bUserLogado) {
            store.commit('setLayout', 'auth');
            return next("/auth/login-boxed");
        }

        if (bTelaTrancada) {
            store.commit('setLayout', 'auth');
            return next("/auth/lockscreen-boxed");
        }

        // Rota de lances: exige lanceweb = 1 no cadastro do cliente
        if (to.meta?.requiresLanceWeb && !store.getters.lanceweb) {
            return next('/');
        }

        // Rota de produtos: exige a empresa ativa liberada para o módulo (a API também recusa)
        if (to.meta?.requiresProdutos && !produtosLiberado(store.getters.cnpjAtivo)) {
            return next('/');
        }

        // Layout fullscreen: autenticado mas sem sidebar/header
        if (to.meta && to.meta.layout && to.meta.layout == 'fullscreen') {
            store.commit('setLayout', 'fullscreen');
        } else {
            store.commit('setLayout', 'app');
        }
    }
    next(true);
});

export default router;
